const logger = require("@/utils/logger");
import decode from "jwt-decode";
import axios from "axios";
import auth0 from "auth0-js";
import Router from "vue-router";
const onestoreutils = require("onestore-utils");
//import Auth0Lock from "auth0-lock";

const config = require("config");
const BASE_URL = config.restAPIURL; //'http://localhost:3000';

const ID_TOKEN_KEY = "id_token";
const ACCESS_TOKEN_KEY = "access_token";

const CLIENT_ID = config.auth0ClientID
const CLIENT_DOMAIN = config.auth0ClientDomain
const SCOPES = "user:full" // + config.auth0EmailScope
const AUDIENCE = config.auth0WebsiteAudience

var router = new Router({
  //mode: "history"
});

var auth0WebAuth = new auth0.WebAuth({
  clientID: CLIENT_ID,
  domain: CLIENT_DOMAIN
});

function parseHashParamsClean() {
  var hashParams = onestoreutils.parseHashParams();
  var cleanParams = {}
  for (var key in hashParams) {
    var value = hashParams[key]
    if (key.startsWith('/')) key = key.substring(1)
    cleanParams[key] = value
  }
  return cleanParams
}

export function detectAuth0Callbacks(loggedInCallback, loginErrorCallback) { //detectOAuthCallback
  var hashParams = parseHashParamsClean();
  if (hashParams.id_token && hashParams.access_token) { // logged in callback
    var appRedirectTo = JSON.parse(hashParams['state'])['appRedirectTo']
    setAccessToken(hashParams.access_token);
    setIdToken(hashParams.id_token);
    loggedInCallback(isLoggedIn(), appRedirectTo)
  }

  if (hashParams.error) { // logging error
    console.error('Login error')
    loginErrorCallback(hashParams.error_description)
  }
}

export function detectLoginError(callback) {
  var hp = onestoreutils.parseHashParams();

  if (hp['/id_token']) hp['id_token'] = hp['/id_token']
  if (hp['/access_token']) hp['access_token'] = hp['/access_token']

  var appRedirectTo = JSON.parse(hp['state'])['appRedirectTo']

  if (hp.id_token && hp.access_token) {
    setAccessToken(hp['access_token']);
    setIdToken(hp['id_token']);
    callback(isLoggedIn(), appRedirectTo)
  }
}

function getCurrentOrigin() {
  if (!window.location.origin) {
    return window.location.protocol + "//" +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
  }
  return window.location.origin
}

export function getHeaders() {
  return {
    Authorization: `Bearer ${getAccessToken()}`
  }
}

export function login(appRedirectTo) {
  var state = {
    appRedirectTo: appRedirectTo
  }

  auth0WebAuth.authorize({
    responseType: "token id_token",
    redirectUri: getCurrentOrigin(),
    audience: AUDIENCE,
    scope: SCOPES,
    state: JSON.stringify(state)
  }, function (err, authResult) {
    if (err) {
      console.error(err)
      logger.log(authResult)
    }
  });
}

export function logout() { // deprecated, use async!!!
  const logoutUrl = 'https://' + config.auth0ClientDomain + '/v2/logout'
  const qs = onestoreutils.formatQueryStringParams({
    returnTo: getCurrentOrigin(),
    client_id: CLIENT_ID
  })
  logger.log('logout URL=' + logoutUrl + qs)
  window.location.href = logoutUrl + qs
}

export function logout_async(callback) { // doesnt work, CORS pb
  const logoutUrl = 'https://' + config.auth0ClientDomain + '/v2/logout'
  const qs = onestoreutils.formatQueryStringParams({
    returnTo: getCurrentOrigin(),
    client_id: CLIENT_ID
  })
  const url = logoutUrl + qs

  return axios
    .get(url)
    .then(response => {
      logger.log(response)
    })
    .catch(err => {
      console.error(err);
    })
}

export function getAuthenticatedUserEmail() {
  var userinfo = getUserInfo()
  if (userinfo) return userinfo[config.auth0EmailScope]
}

export function isSuperAdmin() {
  return getAuthenticatedUserEmail() == 'benjamin.jaton@gmail.com'
}

export function getUserInfo() {
  var token = getAccessToken();
  if (token) {
    var base64Url = token.split('.')[1];
    if (!base64Url) return
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(window.atob(base64));
  }
}

export function deleteSession() {
  clearIdToken();
  clearAccessToken();
}

export function requireAuthThrow() {
  if (!isLoggedIn()) throw 'Not authenticated.'
}

export function requireAuthExpress(to, from, next) {
  if (isLoggedIn()) return next();
  next({
    path: "/"
  });
}

export function requireSuperAdmin(to, from, next) {
  if (isSuperAdmin()) return next();
  next({
    path: "/"
  });
}

export function requireAuthRedirect(to, from, next) {
  if (!isLoggedIn()) {
    logger.log("not logged in");
    router.push('/')
  }
}

export function getIdToken() {
  return localStorage.getItem(ID_TOKEN_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

function clearIdToken() {
  localStorage.removeItem(ID_TOKEN_KEY);
}

function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

// Helper function that will allow us to extract the access_token and id_token
function getParameterByName(name) {
  let match = RegExp("[#&]" + name + "=([^&]*)").exec(window.location.hash);
  return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

// Get and store access_token in local storage
export function setAccessToken(token) {
  let accessToken = token //getParameterByName("access_token");
  logger.log('Setting ' + ACCESS_TOKEN_KEY)
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

// Get and store id_token in local storage
export function setIdToken(token) {
  let idToken = token //getParameterByName("id_token");
  logger.log('Setting ' + ID_TOKEN_KEY)
  localStorage.setItem(ID_TOKEN_KEY, idToken);
}

export function isLoggedIn() {
  const idToken = getIdToken();
  const loggedIn = !!idToken && !isTokenExpired(idToken);
  return loggedIn
}

function getTokenExpirationDate(encodedToken) {
  const token = decode(encodedToken);
  if (!token.exp) {
    return null;
  }

  const date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

function isTokenExpired(token) {
  const expirationDate = getTokenExpirationDate(token);
  return expirationDate < new Date();
}



// WEBPACK FOOTER //
// ./src/utils/auth.js